// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-about-css-modules-js": () => import("/Users/stevelowe/Dropbox/Projects/Pandemonium/src/pages/about-css-modules.js" /* webpackChunkName: "component---src-pages-about-css-modules-js" */),
  "component---src-pages-about-js": () => import("/Users/stevelowe/Dropbox/Projects/Pandemonium/src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-contact-js": () => import("/Users/stevelowe/Dropbox/Projects/Pandemonium/src/pages/contact.js" /* webpackChunkName: "component---src-pages-contact-js" */),
  "component---src-pages-index-js": () => import("/Users/stevelowe/Dropbox/Projects/Pandemonium/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

exports.data = () => import("/Users/stevelowe/Dropbox/Projects/Pandemonium/.cache/data.json")

